(function () {
  function initPopup(root) {
    if (!root || root.dataset.lifeNlReady === '1') return;
    root.dataset.lifeNlReady = '1';

    var storageKey = root.getAttribute('data-storage-key') || 'life_nl_popup_dismissed_v2';
    var delayMs = Math.max(0, parseInt(root.getAttribute('data-delay-ms') || '3000', 10) || 0);
    var forceOpen = root.getAttribute('data-force-open') === '1';
    var openTimer = null;

    var closeButtons = root.querySelectorAll('[data-life-nl-close]');
    var firstFocusable = null;

    function isDismissed() {
      try {
        return window.localStorage.getItem(storageKey) === '1';
      } catch (e) {
        return false;
      }
    }

    function dismiss() {
      try {
        window.localStorage.setItem(storageKey, '1');
      } catch (e) {}
    }

    function openPopup() {
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('life-nl-popup-open');
      firstFocusable =
        root.querySelector('input[type="email"]') ||
        root.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (firstFocusable) {
        window.setTimeout(function () {
          firstFocusable.focus({ preventScroll: true });
        }, 40);
      }
    }

    function closePopup(persist) {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('life-nl-popup-open');
      if (persist) dismiss();
      if (openTimer) {
        window.clearTimeout(openTimer);
        openTimer = null;
      }
    }

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        closePopup(true);
      });
    });

    var form = root.querySelector('form');
    if (form) {
      form.addEventListener('submit', function () {
        var tagsEl = form.querySelector('[data-life-nl-tags], [name="contact[tags]"]');
        var petEl = form.querySelector('[data-life-nl-pet]:checked, [name="contact[note]"]:checked');
        if (!tagsEl) return;
        var base = (tagsEl.getAttribute('data-base-tags') || tagsEl.value || 'newsletter, popup')
          .split(',')
          .map(function (t) { return t.trim(); })
          .filter(function (t) { return t && t.indexOf('pet-') !== 0; });
        if (!tagsEl.getAttribute('data-base-tags')) {
          tagsEl.setAttribute('data-base-tags', base.join(', '));
        }
        if (petEl && petEl.value) {
          var slug = String(petEl.value)
            .toLowerCase()
            .replace(/\s+/g, '-')
            .replace(/[^a-z0-9-]/g, '');
          if (slug) base.push('pet-' + slug);
        }
        tagsEl.value = base.join(', ');
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('is-open')) {
        closePopup(true);
      }
    });

    // After successful Shopify customer form submit, show success then auto-dismiss
    if (forceOpen) {
      openPopup();
      if (root.getAttribute('data-success') === '1') {
        window.setTimeout(function () {
          closePopup(true);
        }, 2800);
      }
      return;
    }

    if (isDismissed()) return;

    openTimer = window.setTimeout(function () {
      openPopup();
    }, delayMs);
  }

  function boot() {
    document.querySelectorAll('[data-life-nl-popup]').forEach(initPopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('[data-life-nl-popup]');
    if (root) {
      root.dataset.lifeNlReady = '';
      initPopup(root);
    }
  });
})();
